import { AUTHORPOSTSEARCHED, CATEGORYSEARCHED, SEARCHED } from "./actionTypes";

export const searched = (inputData) => {
    return {
        type: SEARCHED,
        payload: inputData,
    };
};

export const categorysearched = (inputData) => {
    return {
        type: CATEGORYSEARCHED,
        payload: inputData,
    };
};

export const authorpostsearched = (inputData) => {
    return {
        type: AUTHORPOSTSEARCHED,
        payload: inputData,
    };
};
